module.exports = __webpack_public_path__ + "static/media/bq.8e0a27cf.svg";